import { render, staticRenderFns } from "./CookiesBanner.vue?vue&type=template&id=1ca12300&"
import script from "./CookiesBanner.vue?vue&type=script&lang=js&"
export * from "./CookiesBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\LRStatics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ca12300')) {
      api.createRecord('1ca12300', component.options)
    } else {
      api.reload('1ca12300', component.options)
    }
    module.hot.accept("./CookiesBanner.vue?vue&type=template&id=1ca12300&", function () {
      api.rerender('1ca12300', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/cookies-banner/CookiesBanner.vue"
export default component.exports